import { render, staticRenderFns } from "./AssessmentCreateView.vue?vue&type=template&id=4beaf71a"
import script from "./AssessmentCreateView.vue?vue&type=script&lang=js"
export * from "./AssessmentCreateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports